import { Logo } from '#components/logo.jsx'
import { Markdown } from '#components/markdown.jsx'
import { SkipLink } from '#components/skip-link.jsx'

export function LegalDocument({ document, otherHref, otherTitle }) {
  const updated = new Intl.DateTimeFormat('en', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(document.date))

  return (
    <div className='min-h-svh bg-background text-foreground'>
      <SkipLink />
      <header className='border-b border-border'>
        <div className='mx-auto flex w-full max-w-5xl items-center justify-between gap-6 px-4 py-5 sm:px-6'>
          <Link
            className='rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            href='/'
          >
            <Logo />
          </Link>
          <nav
            aria-label='Legal pages'
            className='flex items-center gap-5 text-sm'
          >
            <Link
              className='text-muted-foreground hover:text-foreground'
              href='/legal/privacy'
            >
              Privacy
            </Link>
            <Link
              className='text-muted-foreground hover:text-foreground'
              href='/legal/terms'
            >
              Terms
            </Link>
          </nav>
        </div>
      </header>

      <main
        className='mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 sm:py-16'
        id='main-content'
        tabIndex='-1'
      >
        <div className='mb-12 border-b border-border pb-8'>
          <p className='mb-3 text-sm font-medium text-muted-foreground'>
            Legal
          </p>
          <h1 className='text-4xl font-semibold tracking-tight sm:text-5xl'>
            {document.title}
          </h1>
          <p className='mt-4 text-sm text-muted-foreground'>
            Document date: {updated}
          </p>
        </div>

        <div className='text-[0.98rem] text-foreground/80'>
          <Markdown>{document.markdown}</Markdown>
        </div>

        <footer className='mt-16 border-t border-border pt-8 text-sm text-muted-foreground'>
          Looking for the {otherTitle.toLowerCase()}?{' '}
          <Link
            className='font-medium text-foreground underline underline-offset-4'
            href={otherHref}
          >
            Read the {otherTitle}
          </Link>
          .
        </footer>
      </main>
    </div>
  )
}
import { Link } from 'arcway/lib/client'
